import { LabelWithHelp } from "@components/common/label-with-help";
import { SdbMemberTypes } from "@custom-types/member-types";
import { AvatarGroup, Grid2, SxProps, Theme } from "@mui/material";
import { TeamMemberAvatar } from "@pages/project-details/project-overview/team-member-avatar";
import { neutral } from "@flat-ui";

interface Props {
  /** List of member */
  members: SdbMemberTypes[];

  /** Maximum number of avatars need to display */
  maxMemberAvatars: number;

  /** Title for the avatar groups */
  label?: string;

  /** Total number of members */
  membersCount?: number;

  /** Props for the avatar */
  avatarSx?: SxProps<Theme>;
}

/** Renders members avatar group */
export function MemberAvatars({
  members,
  maxMemberAvatars,
  label,
  membersCount,
  avatarSx,
}: Props): JSX.Element {
  const shouldShowRemainingMembersCount =
    members.length > maxMemberAvatars ||
    (membersCount && membersCount > maxMemberAvatars);
  const remainingMemberCount = membersCount
    ? membersCount - maxMemberAvatars
    : undefined;

  return (
    <Grid2 container alignItems="flex-end" justifyContent="space-between">
      <Grid2>
        {label && (
          <LabelWithHelp
            title={label}
            sx={{
              color: neutral[500],
              fontWeight: "normal",
              fontSize: "11px",
            }}
          />
        )}

        <AvatarGroup
          sx={{ justifyContent: "flex-end" }}
          max={maxMemberAvatars + 1}
        >
          {/* Only show the first section of the members */}
          {members.slice(0, maxMemberAvatars).map((member) => (
            <TeamMemberAvatar
              key={member.identity}
              member={member}
              avatarSx={avatarSx}
            />
          ))}
          {shouldShowRemainingMembersCount && (
            <TeamMemberAvatar
              key="more-members"
              // Show the remaining members
              members={members.slice(maxMemberAvatars)}
              membersCount={remainingMemberCount}
              avatarSx={avatarSx}
            />
          )}
        </AvatarGroup>
      </Grid2>
    </Grid2>
  );
}
